/**
 * Shared date formatting for expert publications and clinical trials.
 *
 * Both the publications list and the clinical-trials list show a "Mon YYYY"
 * date in their muted subline, derived from a nullable numeric year + month
 * (the API returns partial dates: year is usually present, month often, never
 * a day). Centralised here so the two sections — and any future surface that
 * shows the same data — format dates identically.
 */

const MONTH_ABBREVIATIONS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

/**
 * Formats a partial publication date as "Mon YYYY", falling back to "YYYY" when
 * the month is absent and to null when the year is absent (so callers can omit
 * the date entirely).
 */
export function formatPublicationDate(
  year: number | null | undefined,
  month: number | null | undefined
): string | null {
  if (!year) {
    return null;
  }

  if (month && month >= 1 && month <= 12) {
    return `${MONTH_ABBREVIATIONS[month - 1]} ${year}`;
  }

  return String(year);
}
